import { useMutation } from '@tanstack/react-query'
import { uploadTimesheetFile } from './uploadTimesheetFile'
import { ImportedReward } from './types'

export function useUploadTimesheetFileMutation(
  props: {
    companyId: string
    onSuccess?: (data: ImportedReward[]) => void
    onError?: (error: unknown) => void
  },
) {
  return useMutation({
    mutationFn: async ({ file } : { file: File }) => {
      const { data } = await uploadTimesheetFile({
        companyId: props.companyId,
        file,
      })
      return data
    },

    onError: (error) => {
      console.error('Error useUploadTimesheetFileMutation:', error)
      if (props.onError) props.onError(error)
    },

    onSuccess: (data) => {
      if (props.onSuccess) props.onSuccess(data)
    },
  })
}
